import type {
	MarketViewBulkSaveRequest,
	MarketViewResponse,
	SelectableStrategyConstraintsResponse,
} from "@eu.mdotm.api/sphere";
import type { EditPortfolioMultiV4Props } from "./EditPortfolioMulti.shared-types";
import type { EditPortfolioMultiV4StepPayloadMap } from "./shared-multi";

type EditPortfolioMultiV4BackendRequestPayloadMap = {
	marketView: MarketViewBulkSaveRequest;
};

type EditPortfolioMultiV4BackendResponsePayloadMap = {
	portfolioStrategy: SelectableStrategyConstraintsResponse;
	marketView: MarketViewResponse;
};

export const responseToStepMapper: {
	[K in keyof EditPortfolioMultiV4StepPayloadMap]: (
		backendData: EditPortfolioMultiV4BackendResponsePayloadMap[K],
		area: EditPortfolioMultiV4Props["area"],
	) => EditPortfolioMultiV4StepPayloadMap[K];
} = {
	marketView: (mv) => ({
		scenarioData: mv.scenarioData,
		scenarioIdentifier: mv.scenarioIdentifier,
		forecastHorizon: mv.scenarioData?.forecastHorizon,
		custom: undefined,
		name: undefined,
	}),
};

export function makeStepToRequestMapper(proposalUuid: string | undefined): {
	[K in keyof EditPortfolioMultiV4StepPayloadMap]: (
		frontendData: EditPortfolioMultiV4StepPayloadMap[K],
	) => EditPortfolioMultiV4BackendRequestPayloadMap[K];
} {
	return {
		marketView: (a) =>
			({
				bulkUUID: proposalUuid,
				scenarioIdentifier: a.scenarioIdentifier,
				custom: a.custom,
				flexibleExpectedReturnsVolatility: a.scenarioData?.flexibleExpectedReturnsVolatility,
				defaultRegimeProbabilities: a.scenarioData?.regimeProbabilities,
				userRegimeProbabilities: a.scenarioData?.regimeUserProbability,
				forecastHorizon: a.scenarioData?.forecastHorizon,
				positioningIndicators: a.scenarioData?.positioningIndicators,
				marketViewType: a.scenarioData?.marketViewType,
			}) satisfies NonNullable<EditPortfolioMultiV4BackendRequestPayloadMap["marketView"]>,
	};
}
